const ROOT_DOMAIN = "snapshot.live";
const SESSION_KEY = "brand-preview";

export interface BrandTarget {
  subdomain: string;
  isPreview: boolean;
  wantsDraft: boolean;
}

/** Resolve the brand from ?brand= override (session-scoped) or the hostname. */
export function resolveBrandTarget(): BrandTarget | null {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  const override = params.get("brand");

  if (override === "" || override === "none") {
    sessionStorage.removeItem(SESSION_KEY);
    return null;
  }
  if (override) {
    const value = { subdomain: override.toLowerCase(), draft: params.get("preview") === "draft" };
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(value));
  }
  const stored = sessionStorage.getItem(SESSION_KEY);
  if (stored) {
    try {
      const v = JSON.parse(stored);
      return { subdomain: v.subdomain, isPreview: true, wantsDraft: !!v.draft };
    } catch { /* ignore */ }
  }

  const host = window.location.hostname.toLowerCase();
  if (!host.endsWith(`.${ROOT_DOMAIN}`)) return null;
  const sub = host.slice(0, -(ROOT_DOMAIN.length + 1));
  if (!sub || sub === "www" || sub.includes(".")) return null;
  return { subdomain: sub, isPreview: false, wantsDraft: false };
}

export function exitBrandPreview() {
  sessionStorage.removeItem(SESSION_KEY);
  const url = new URL(window.location.href);
  url.searchParams.delete("brand");
  url.searchParams.delete("preview");
  window.location.replace(url.toString());
}
